import { Modal } from "App/Component/ui"
import React from "react"

const ModalPreviewBillingObatKronis = ({ setShowModal, dataPDF }) => {
  return (
    <Modal title={"Preview Billing Obat Kronis"} show={setShowModal} width="50%">
      <iframe src={dataPDF} width="100%" height="600px" title="PDF Preview" />
    </Modal>
  )
}

export default ModalPreviewBillingObatKronis
